import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * refresh-parent-portal-ui 0.1: the sticky action bar. `[primary]` and
 * `[secondary]` slots. Stacked at the bottom on phones (safe-area padding);
 * right-aligned inline from 768 px.
 */
@Component({
  selector: 'ui-action-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bar">
      <span class="secondary"><ng-content select="[secondary]"></ng-content></span>
      <span class="primary"><ng-content select="[primary]"></ng-content></span>
    </div>
  `,
  styles: [
    `
      :host {
        position: sticky;
        bottom: 0;
        z-index: 10;
        display: block;
        margin-top: 16px;
        /* phones: the bar sits over the page bottom with safe-area padding */
        padding: 10px 0 calc(4px + env(safe-area-inset-bottom, 0px));
        background: linear-gradient(rgba(251, 247, 239, 0), var(--gp-bg) 30%);
      }
      .bar {
        display: flex;
        flex-direction: column-reverse;
        gap: 10px;
      }
      .primary,
      .secondary {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .primary :where(button, a),
      .secondary :where(button, a) {
        width: 100%;
      }
      @media (min-width: 768px) {
        :host {
          position: static;
          padding: 0;
          background: none;
        }
        .bar {
          flex-direction: row;
          justify-content: flex-end;
        }
        .primary,
        .secondary {
          flex-direction: row;
        }
        .primary :where(button, a),
        .secondary :where(button, a) {
          width: auto;
        }
      }
    `,
  ],
})
export class UiActionBarComponent {}